<template>
    <section class="bgcc">
        <div class="container pt-40 pb-20 mx-auto sm:w-full md:w-3/4 lg:w-2/4">
            <div class="w-full px-4 mb-4 lg:mx-auto lg:w-1/2">
                <h1 class="mb-2 text-xl font-semibold text-center text-gray-800 dark:text-gray-200">ยืนยันสะสางดอกเบี้ย</h1>
            </div>
            <div class="flex ml-10 mr-10 rounded-lg bg-gray-50 dark:bg-gray-900">
                <!-- desktop show -->
                <div  class="flex-1 hidden max-w-4xl m-5 md:block lg:block">
                    <!-- <div class="flex flex-col md:flex-row">
                        <div class="sm:p-1 md:p-1 sm:w-full md:w-4/5">
                            <u><b>สะสางดอกเบี้ยในหมวดหมู่ :- </b></u>
                        </div>
                    </div> -->
                    <div class="flex flex-col md:flex-row">
                        <div class="font-bold sm:p-1 md:p-1 sm:w-full md:w-2/4">
                            <!-- {{cleanupTypeText(cleanupType)}} : -->
                            จำนวนเงิน
                        </div>
                        <div class="md:text-right sm:p-1 md:p-1 sm:w-full md:w-2/4">
                            {{showMoney(money)}} บาท
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row">
                        <div class="font-bold sm:p-1 md:p-1 sm:w-full md:w-2/4">
                            ธนาคารกสิกรไทย สาขายะลา 099-8-33940-5 
                        </div>
                        <div class="md:text-right sm:p-1 md:p-1 sm:w-full md:w-2/4">
                            <span class="text-sm font-bold text-red-500" style="margin-top: -15px">
                                <button @click.stop.prevent="copyToClipboard()"  class="px-1 py-1 mb-2 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-green-600 border border-transparent rounded-lg cursor-pointer active:bg-purple-600 hover:bg-purple-700">
                                    <div class="flex">
                                        <span>คัดลอก</span> 
                                        <svg class="w-5 h-5" :class="{'hidden': is_copied}" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </button>
                                <input type="hidden" id="accountNumber" value="0998339405">
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row">
                        <div class="font-bold sm:p-1 md:p-1 sm:w-full md:w-1/4">
                            ชื่อบัญชี :
                        </div>
                        <div class="md:text-right sm:p-1 md:p-1 sm:w-full md:w-3/4">
                            มูลนิธิจูจีสร้างสรรค์สังคม (กองทุนสะสางดอกเบี้ย)
                        </div>
                    </div>
                </div>
                <!-- \.desktop show -->

                <!-- mobile show -->
                <div  class="flex-1 max-w-4xl m-5 md:hidden lg:hidden">
                    <div class="flex flex-col md:flex-row">
                        <div class="font-bold sm:p-1 md:p-1 sm:w-full md:w-2/4">
                            จำนวนเงิน : {{showMoney(money)}} บาท
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row">
                        <div class="font-bold sm:p-1 md:p-1 sm:w-full md:w-2/4">
                            โอนเข้าบัญชีธนาคารกสิกรไทย สาขายะลา 099-8-33940-5 
                            <span class="text-sm font-bold text-red-500" style="margin-top: -15px">
                                <button @click.stop.prevent="copyToClipboard()"  class="px-1 py-1 mb-2 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-green-600 border border-transparent rounded-lg cursor-pointer active:bg-purple-600 hover:bg-purple-700">
                                    <div class="flex">
                                        <span>คัดลอก</span> 
                                        <svg class="w-5 h-5" :class="{'hidden': is_copied}" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </button>
                                <input type="hidden" id="accountNumber" value="0998339405">
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row">
                        <div class="font-bold sm:p-1 md:p-1 sm:w-full md:w-1/4">
                            ชื่อบัญชี : มูลนิธิจูจีสร้างสรรค์สังคม (กองทุนสะสางดอกเบี้ย)
                        </div>
                    </div>
                </div>
                <!-- \.mobile show -->
            </div>
            
            <form @submit.prevent="cleanupSubmit()">
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="mt-2 mr-1 md:mr-1 lg:mr-1 sm:w-full md:w-2/4">
                                วันที่โอน
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="w-4/12 mt-1 mr-1 md:mr-1 lg:mr-1">
                                <select class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none"
                                    :class="{'border-red-500': serverError.year}"
                                    v-model="year">
                                    <option style="display: none">--ปี--</option>
                                    <option v-for="(year, index) in yearList" :value="year" :key="index">{{year}}</option>
                                </select>
                                <div v-if="serverError.year" class="mt-2 text-sm text-red-500">
                                    {{serverError.year[0]}}
                                </div>
                            </div>
                            <div class="w-4/12 mt-1 ml-1 md:ml-1 lg:ml-1">
                                <select class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none"
                                    :class="{'border-red-500': serverError.month}"
                                    v-model="month"
                                    @change="changeMonth($event.target.value)">
                                    <option value="" style="display: none">--เดือน--</option>
                                    <option v-for="(month, index) in 12" :value="formatMonth(month)" :key="index">{{formatMonth(month)}}</option>
                                </select>
                                <div v-if="serverError.month" class="mt-2 text-sm text-red-500">
                                    {{serverError.month[0]}}
                                </div>
                            </div>
                            <div class="w-4/12 mt-1 ml-1 md:ml-1 lg:ml-1">
                                <select class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none"
                                    :class="{'border-red-500': serverError.day}"
                                    v-model="day">
                                    <option value="" style="display: none">--วันที่--</option>
                                    <option v-for="(day, index) in dayList" :value="day" :key="index">
                                        {{formatDay(day)}}
                                    </option>
                                </select>
                                <div v-if="serverError.day" class="mt-2 text-sm text-red-500">
                                    {{serverError.day[0]}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="mt-2 mr-1 md:mr-1 lg:mr-1 sm:w-full md:w-2/4">
                                เวลาโอน
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="w-2/4 mt-1 mr-1 md:mr-1 lg:mr-1">
                                <select class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none"
                                    :class="{'border-red-500': serverError.hour}"
                                    v-model="hour">
                                    <option value="" style="display: none">--ชั่วโมง--</option>
                                    <option v-for="(h, index) in 24" :value="hourFormat(index)" :key="index">{{hourFormat(index)}}</option>
                                </select>
                                <div v-if="serverError.hour" class="mt-2 text-sm text-red-500">
                                    {{serverError.hour[0]}}
                                </div>
                            </div>
                            <div class="w-2/4 mt-1 ml-1 md:ml-1 lg:ml-1">
                                <select class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none"
                                    :class="{'border-red-500': serverError.minute}"
                                    v-model="minute">
                                    <option value="" style="display: none">--นาที--</option>
                                    <option v-for="(m, index) in 60" :value="minuteFormat(index)" :key="index">{{minuteFormat(index)}}</option>
                                </select>
                                <div v-if="serverError.minute" class="mt-2 text-sm text-red-500">
                                    {{serverError.minute[0]}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="mt-2 mr-1 md:mr-1 lg:mr-1 sm:w-full md:w-2/4">
                                หลักฐานการโอนเงิน
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="mt-1 mr-1 md:mr-1 lg:mr-1 sm:w-full md:w-2/4">
                                <input type="file"
                                    class="w-full px-3 py-2 leading-tight text-gray-700 bg-white bg-auto border rounded"
                                    :class="{'border-red-500': serverError.slip}"
                                    @change="onFileChange">
                                <div v-if="serverError.slip" class="mt-2 text-sm text-red-500">
                                    {{serverError.slip[0]}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="mt-2 mr-1 md:mr-1 lg:mr-1 sm:w-full md:w-2/4">
                                หมายเหตุ
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex ml-10 mr-10 rounded-lg">
                    <div  class="flex-1 max-w-4xl">
                        <div class="flex md:flex-row">
                            <div class="w-full mt-1 mr-1 md:mr-1 lg:mr-1">
                                <textarea rows="5"
                                class="w-full px-3 py-2 leading-tight text-gray-700 bg-white bg-auto border rounded"
                                :class="{'border-res-500': serverError.description}"
                                v-model="description"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex mt-2 ml-10 mr-10 rounded-lg ">
                    <button
                        class="w-full mt-1 btncc-riba"
                        :class="{'opacity-50 cursor-not-allowed': disabled}"
                        :disabled="disabled">
                    ยืนยันการสะสางดอกเบี้ย
                    </button>
                </div>
            </form>
        </div> 
    </section>
</template>

<script>
    import filter from '@/helpers/filter.js'
    import http from '@/services/FrontendService.js'
    // import unLoginhttp from '@/services/AuthService.js'
    import moment from 'moment'
    export default {
        mounted(){
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        data(){
            return{
                serverError: '',
                disabled: false,
                yearList: [],
                dayList: [],
                //form
                name: '',
                lastname: '',
                email: '',
                telephone: '',
                money: localStorage.getItem('riba_amount'),
                year: '',
                month: '',
                day: '',
                hour: '',
                minute: '',
                slip: '',
                imgUrl: '',
                description: '',
                is_copied: true,
            }
        },
        created(){
            window.location.hash = 'top'

            let beforThisyear = moment().subtract(1, 'year').format("YYYY")
            let yearList = [parseInt(beforThisyear)]
            this.yearList.push(parseInt(beforThisyear))
            let i = 1
            while(i < 2){
                yearList.push(parseInt(yearList[i-1])+1)
                this.yearList.push(parseInt(yearList[i-1])+1)
                i++
            }
            this.year = moment().format("YYYY")
            this.month = moment().format("MM")
            this.dayList = moment().daysInMonth()
            this.day = moment().format("D")
            
        },
        methods:{
            cleanupSubmit(){
                this.disabled = true
                this.$Progress.start()
                let data = new FormData()
                // data.append('receipt', JSON.parse(localStorage.getItem('cuciCleanupForm')).receipt)
                data.append("money", this.money)
                data.append("year", this.year)
                data.append("month", this.month)
                data.append("day", this.day)
                data.append("hour", this.hour)
                data.append('minute', this.minute)
                data.append('slip', this.slip)
                data.append('_method', 'patch')
                http.post('transaction/ribaUploadSlip', data)
                    .then(() => {
                        this.serverError = ''
                        this.$swal.fire({
                            icon: 'success',
                            title: 'สำเร็จ',
                            text: 'ขอบคุณที่สะสางดอกเบี้ยกับ จูจี ขอความบารอกัตบังเกิดแก่ท่าน',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.$router.push({name: 'Riba'})
                            localStorage.removeItem('riba_amount')
                        });   
                        this.disabled = false
                        this.$Progress.finish()
                    })
                    .catch(error => {
                        this.serverError = error.response.data.errors
                        this.disabled = false
                        this.$Progress.fail()
                    })
            },
            minuteFormat(m){
                return moment(m, "mm").format("mm")
            },
            hourFormat(h){
                return moment(h, "HH").format("HH")
            },
            changeMonth(month){
               this.dayList = moment(moment().month(month-1).year(this.year).format('YYYY-MM')).daysInMonth()
            },
            formatMonth(month){
                return moment(month, "m").format("mm")
            },
            formatDay(d){
                return filter.dayFormat(d)
            },
            // cleanupSubmit(){
            //     let data = new FormData()
            //     // data.append('receipt', JSON.parse(localStorage.getItem('cuciCleanupForm')).receipt)
            //     data.append("money", this.money)
            //     data.append("year", this.year)
            //     data.append("month", this.month)
            //     data.append("day", this.day)
            //     data.append("hour", this.hour)
            //     data.append('minute', this.minute)
            //     data.append('slip', this.slip)
            //     data.append('cleanup_type', this.cleanupType)
            //     data.append('description', this.description)
            //     data.append('cref', localStorage.getItem('cref'))
            //     data.append('_method', 'patch')
            //     let url = ''
            //     if(this.isLogedIn){
            //         // data.append('userFormType', 'member')
            //         url = http.post('cleanup/confirming', data)
            //     }else{
            //         // data.append('userFormType', 'visitor')
            //         url = unLoginhttp.post('unsigninCleanup/confirm', data)
            //     }
            //     this.disabled = true
            //     this.$Progress.start()
            //     url.then(() => {
            //             this.$Progress.finish()
            //             this.disabled = false
            //             this.serverError = ''
            //             this.$swal.fire({
            //                 icon: 'success',
            //                 title: 'สำเร็จ',
            //                 text: 'ขอบคุณที่สะสางดอกเบี้ยกับ จูจี ขอความบารอกัตบังเกิดแก่ท่าน',
            //                 confirmButtonText: 'OK'
            //             }).then(() => {
            //                 this.$router.push({name: 'Cleanup'})
            //                 localStorage.removeItem('cuciCheckoutMoney')
            //                 this.cuciCleanupForm.receipt = false
            //                 localStorage.setItem('cuciCleanupForm', JSON.stringify(this.cuciCleanupForm))
            //             });
            //         }).catch(error => {
            //             this.$Progress.fail()
            //             this.disabled = false
            //             this.serverError = error.response.data.errors
            //     })
            // },
            showMoney(money){
                return filter.numberFormat(money, '0,0.00')
            },
            onFileChange(e){
                const slip = e.target.files[0]
                this.slip = e.target.files[0]
                this.imgUrl = URL.createObjectURL(slip)
                
            },
            // cleanupTypeText(id){
            //    return  filter.cleanupType(id)
            // },
            copyToClipboard(){
                let accountNumber = document.querySelector('#accountNumber')
                accountNumber.setAttribute('type', 'text')
                accountNumber.select()
                try {
                    document.execCommand('copy');
                    this.is_copied = false
                } catch (err) {
                    alert('Oops, unable to copy');
                }
                /* unselect the range */
                accountNumber.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges() 
            },
        }   
    }
</script>

<style lang="scss" scoped>

</style>